/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * application
 * OpenAPI spec version: 1.0.0-20260816-002920-566f5d59
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import {
  useCallback
} from 'react';

import { useMutator } from '../../useMutator';
export interface Address1 {
  street: string;
  houseNumberSuffix: string;
  lines?: string[];
  city: string;
  houseNumber: string;
  postalCode: string;
  countryCode: string;
}

export type ServicePointDeliveryUpdatePreferenceType = typeof ServicePointDeliveryUpdatePreferenceType[keyof typeof ServicePointDeliveryUpdatePreferenceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ServicePointDeliveryUpdatePreferenceType = {
  ServicePointDelivery: 'ServicePointDelivery',
} as const;

export interface ServicePointDeliveryUpdate {
  psfKey: string;
  preferenceType: ServicePointDeliveryUpdatePreferenceType;
}

export type InterventionPreference = AgreedPlaceInterventionPreference | ServicePointInterventionPreference;

export interface DeliveryPreference {
  agreedPlaceSettings?: AgreedPlaceSettings;
  addressName: string;
  address: Address1;
  servicePointSettings?: ServicePointSettings;
  activeSetting: ActiveSetting;
  addressId: string;
  availableOptions: AvailableOptions;
}

export interface AgreedPlacePermanentlyUnavailable {
  acknowledged: boolean;
}

export interface AgreedPlaceInterventionPreference {
  description: string;
  active: boolean;
  available?: boolean;
  ringDoorbell?: boolean;
}

export interface AvailableOptions {
  isServicePointAvailable: boolean;
  isAgreedPlaceAvailable: boolean;
  availableServicePointIds?: string[];
}

export interface SinglePreference {
  userId: string;
  preference: AddressInterventionPreference;
}

export type DisableCause = AddressUpdated | AgreedPlacePermanentlyUnavailable | ServicePointPermanentlyUnavailable | ServicePointTemporarilyUnavailable;

export type Fallback = AgreedPlaceDelivery | NoPreference;

export type AgreedPlaceDeliveryUpdatePreferenceType = typeof AgreedPlaceDeliveryUpdatePreferenceType[keyof typeof AgreedPlaceDeliveryUpdatePreferenceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AgreedPlaceDeliveryUpdatePreferenceType = {
  AgreedPlaceDelivery: 'AgreedPlaceDelivery',
} as const;

export interface AgreedPlaceDeliveryUpdate {
  description: string;
  preferenceType: AgreedPlaceDeliveryUpdatePreferenceType;
}

export interface ServicePointPermanentlyUnavailable {
  acknowledged: boolean;
}

export interface CheckAddressUpdate {
  address: Address;
}

export interface CombinedNotifications {
  userId: string;
  notifications?: AddressPreferenceNotification[];
}

export interface WhatsNewFeatures {
  features?: WhatsNew[];
}

export type PreferenceUpdateFallback = AgreedPlaceDeliveryUpdate | NoPreferenceUpdate;

export type DoorDeliveryPreferenceType = typeof DoorDeliveryPreferenceType[keyof typeof DoorDeliveryPreferenceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DoorDeliveryPreferenceType = {
  DoorDelivery: 'DoorDelivery',
} as const;

export interface DoorDelivery {
  fallback: Fallback;
  preferenceType: DoorDeliveryPreferenceType;
}

export interface ServicePointInterventionPreference {
  active: boolean;
  name: string;
  depot: string;
  availableServicePointIds?: string[];
  psfKey: string;
  available?: boolean;
}

export interface AgreedPlaceSettings {
  description: string;
}

export type NoPreferencePreferenceType = typeof NoPreferencePreferenceType[keyof typeof NoPreferencePreferenceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NoPreferencePreferenceType = {
  NoPreference: 'NoPreference',
} as const;

export interface NoPreference {
  preferenceType: NoPreferencePreferenceType;
}

export interface ServicePointSettings {
  psfKey: string;
  servicepointName: string;
}

export type ServicePointDeliveryPreferenceType = typeof ServicePointDeliveryPreferenceType[keyof typeof ServicePointDeliveryPreferenceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ServicePointDeliveryPreferenceType = {
  ServicePointDelivery: 'ServicePointDelivery',
} as const;

export interface ServicePointDelivery {
  preferenceType: ServicePointDeliveryPreferenceType;
}

export interface DeliveryPreferencesResponse {
  preferences?: DeliveryPreference[];
}

export interface AddressUpdated {
  last: Address;
  acknowledged: boolean;
}

export interface Address {
  city: string;
  postalCode: string;
  street: string;
  houseNumberSuffix: string;
  lines?: string[];
  countryCode: string;
  houseNumber: string;
}

export interface AddressInterventionPreference {
  address: Address;
  addressId: string;
  servicePoint: ServicePointInterventionPreference;
  addressName: string;
  agreedPlace: AgreedPlaceInterventionPreference;
}

export interface AddressInterventionPreferenceOptions {
  isServicePointAvailable: boolean;
  isAgreedPlaceAvailable: boolean;
  availableServicePointIds?: string[];
}

export interface AppError {
  key: string;
  message: string;
}

export interface DeliveryPreferenceResponse {
  preference: DeliveryPreference;
}

export interface ServicePointTemporarilyUnavailable {
  fromDate: string;
  toDate: string;
  acknowledged: boolean;
}

export type DoorDeliveryUpdatePreferenceType = typeof DoorDeliveryUpdatePreferenceType[keyof typeof DoorDeliveryUpdatePreferenceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DoorDeliveryUpdatePreferenceType = {
  DoorDelivery: 'DoorDelivery',
} as const;

export interface DoorDeliveryUpdate {
  fallback: PreferenceUpdateFallback;
  preferenceType: DoorDeliveryUpdatePreferenceType;
}

export interface UpdateDeliveryPreferenceRequest {
  preference: PreferenceUpdate;
}

export interface CombinedPreferences {
  userId: string;
  preferences?: AddressInterventionPreference[];
}

export type NoPreferenceUpdatePreferenceType = typeof NoPreferenceUpdatePreferenceType[keyof typeof NoPreferenceUpdatePreferenceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NoPreferenceUpdatePreferenceType = {
  NoPreference: 'NoPreference',
} as const;

export interface NoPreferenceUpdate {
  preferenceType: NoPreferenceUpdatePreferenceType;
}

export interface UpdateInterventionPreference {
  preference: InterventionPreference;
}

export type WhatsNewName = typeof WhatsNewName[keyof typeof WhatsNewName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WhatsNewName = {
  'agreed-place-picture': 'agreed-place-picture',
} as const;

export interface WhatsNew {
  name: WhatsNewName;
  preferences?: AddressInterventionPreference[];
}

export type AgreedPlaceDeliveryPreferenceType = typeof AgreedPlaceDeliveryPreferenceType[keyof typeof AgreedPlaceDeliveryPreferenceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AgreedPlaceDeliveryPreferenceType = {
  AgreedPlaceDelivery: 'AgreedPlaceDelivery',
} as const;

export interface AgreedPlaceDelivery {
  preferenceType: AgreedPlaceDeliveryPreferenceType;
}

export type PreferenceUpdate = DoorDeliveryUpdate | ServicePointDeliveryUpdate | AgreedPlaceDeliveryUpdate;

export interface AddressPreferenceNotification {
  addressId: string;
  addressName: string;
  disabledBy: DisableCause;
  psfKey?: string;
}

export type ActiveSetting = DoorDelivery | ServicePointDelivery | AgreedPlaceDelivery;

export interface AddressChecked {
  userId: string;
  notification?: AddressPreferenceNotification;
}

export const useGetDeliveryPreferencesHook = () => {
        const getDeliveryPreferences = useMutator<DeliveryPreferencesResponse>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return getDeliveryPreferences(
          {url: `/delivery-preferences`, method: 'GET', signal
    },
          );
        }, [getDeliveryPreferences])
      }
    

export const getGetDeliveryPreferencesQueryKey = () => {
    return [`/delivery-preferences`] as const;
    }

    
export const useGetDeliveryPreferencesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetDeliveryPreferencesHook>>>, TError = AppError | AppError | AppError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDeliveryPreferencesHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDeliveryPreferencesQueryKey();

  const getDeliveryPreferences =  useGetDeliveryPreferencesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetDeliveryPreferencesHook>>>> = ({ signal }) => getDeliveryPreferences(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDeliveryPreferencesHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDeliveryPreferencesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetDeliveryPreferencesHook>>>>
export type GetDeliveryPreferencesQueryError = AppError | AppError | AppError


export function useGetDeliveryPreferences<TData = Awaited<ReturnType<ReturnType<typeof useGetDeliveryPreferencesHook>>>, TError = AppError | AppError | AppError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDeliveryPreferencesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetDeliveryPreferencesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetDeliveryPreferencesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDeliveryPreferences<TData = Awaited<ReturnType<ReturnType<typeof useGetDeliveryPreferencesHook>>>, TError = AppError | AppError | AppError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDeliveryPreferencesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetDeliveryPreferencesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetDeliveryPreferencesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDeliveryPreferences<TData = Awaited<ReturnType<ReturnType<typeof useGetDeliveryPreferencesHook>>>, TError = AppError | AppError | AppError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDeliveryPreferencesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetDeliveryPreferences<TData = Awaited<ReturnType<ReturnType<typeof useGetDeliveryPreferencesHook>>>, TError = AppError | AppError | AppError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDeliveryPreferencesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetDeliveryPreferencesQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePutAcknowledgeDisabledPreferenceHook = () => {
        const putAcknowledgeDisabledPreference = useMutator<CombinedPreferences>();

        return useCallback((
    addressId: string,
 ) => {
        return putAcknowledgeDisabledPreference(
          {url: `/intervention-preferences/${addressId}/acknowledge`, method: 'PUT'
    },
          );
        }, [putAcknowledgeDisabledPreference])
      }
    


export const usePutAcknowledgeDisabledPreferenceMutationOptions = <TError = AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutAcknowledgeDisabledPreferenceHook>>>, TError,{addressId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutAcknowledgeDisabledPreferenceHook>>>, TError,{addressId: string}, TContext> => {

const mutationKey = ['putAcknowledgeDisabledPreference'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const putAcknowledgeDisabledPreference =  usePutAcknowledgeDisabledPreferenceHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePutAcknowledgeDisabledPreferenceHook>>>, {addressId: string}> = (props) => {
          const {addressId} = props ?? {};

          return  putAcknowledgeDisabledPreference(addressId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAcknowledgeDisabledPreferenceMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePutAcknowledgeDisabledPreferenceHook>>>>
    
    export type PutAcknowledgeDisabledPreferenceMutationError = AppError | AppError | AppError

    export const usePutAcknowledgeDisabledPreference = <TError = AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutAcknowledgeDisabledPreferenceHook>>>, TError,{addressId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePutAcknowledgeDisabledPreferenceHook>>>,
        TError,
        {addressId: string},
        TContext
      > => {

      const mutationOptions = usePutAcknowledgeDisabledPreferenceMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deprecated. Use GET /delivery-preferences
 * @deprecated
 */
export const useGetInterventionPreferencesHook = () => {
        const getInterventionPreferences = useMutator<CombinedPreferences>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return getInterventionPreferences(
          {url: `/intervention-preferences`, method: 'GET', signal
    },
          );
        }, [getInterventionPreferences])
      }
    

export const getGetInterventionPreferencesQueryKey = () => {
    return [`/intervention-preferences`] as const;
    }

    
export const useGetInterventionPreferencesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetInterventionPreferencesHook>>>, TError = AppError | AppError | AppError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetInterventionPreferencesHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInterventionPreferencesQueryKey();

  const getInterventionPreferences =  useGetInterventionPreferencesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetInterventionPreferencesHook>>>> = ({ signal }) => getInterventionPreferences(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetInterventionPreferencesHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInterventionPreferencesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetInterventionPreferencesHook>>>>
export type GetInterventionPreferencesQueryError = AppError | AppError | AppError


export function useGetInterventionPreferences<TData = Awaited<ReturnType<ReturnType<typeof useGetInterventionPreferencesHook>>>, TError = AppError | AppError | AppError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetInterventionPreferencesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetInterventionPreferencesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetInterventionPreferencesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInterventionPreferences<TData = Awaited<ReturnType<ReturnType<typeof useGetInterventionPreferencesHook>>>, TError = AppError | AppError | AppError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetInterventionPreferencesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetInterventionPreferencesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetInterventionPreferencesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInterventionPreferences<TData = Awaited<ReturnType<ReturnType<typeof useGetInterventionPreferencesHook>>>, TError = AppError | AppError | AppError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetInterventionPreferencesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useGetInterventionPreferences<TData = Awaited<ReturnType<ReturnType<typeof useGetInterventionPreferencesHook>>>, TError = AppError | AppError | AppError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetInterventionPreferencesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetInterventionPreferencesQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetPreferenceOptionsHook = () => {
        const getPreferenceOptions = useMutator<AddressInterventionPreferenceOptions>();

        return useCallback((
    countryCode: string,
    postalCode: string,
 signal?: AbortSignal
) => {
        return getPreferenceOptions(
          {url: `/intervention-preference-options/${countryCode}/${postalCode}`, method: 'GET', signal
    },
          );
        }, [getPreferenceOptions])
      }
    

export const getGetPreferenceOptionsQueryKey = (countryCode?: string,
    postalCode?: string,) => {
    return [`/intervention-preference-options/${countryCode}/${postalCode}`] as const;
    }

    
export const useGetPreferenceOptionsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetPreferenceOptionsHook>>>, TError = AppError | AppError | AppError>(countryCode: string,
    postalCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPreferenceOptionsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPreferenceOptionsQueryKey(countryCode,postalCode);

  const getPreferenceOptions =  useGetPreferenceOptionsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetPreferenceOptionsHook>>>> = ({ signal }) => getPreferenceOptions(countryCode,postalCode, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(countryCode && postalCode), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPreferenceOptionsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPreferenceOptionsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetPreferenceOptionsHook>>>>
export type GetPreferenceOptionsQueryError = AppError | AppError | AppError


export function useGetPreferenceOptions<TData = Awaited<ReturnType<ReturnType<typeof useGetPreferenceOptionsHook>>>, TError = AppError | AppError | AppError>(
 countryCode: string,
    postalCode: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPreferenceOptionsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetPreferenceOptionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetPreferenceOptionsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPreferenceOptions<TData = Awaited<ReturnType<ReturnType<typeof useGetPreferenceOptionsHook>>>, TError = AppError | AppError | AppError>(
 countryCode: string,
    postalCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPreferenceOptionsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetPreferenceOptionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetPreferenceOptionsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPreferenceOptions<TData = Awaited<ReturnType<ReturnType<typeof useGetPreferenceOptionsHook>>>, TError = AppError | AppError | AppError>(
 countryCode: string,
    postalCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPreferenceOptionsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPreferenceOptions<TData = Awaited<ReturnType<ReturnType<typeof useGetPreferenceOptionsHook>>>, TError = AppError | AppError | AppError>(
 countryCode: string,
    postalCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPreferenceOptionsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetPreferenceOptionsQueryOptions(countryCode,postalCode,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePostCheckAddressUpdateHook = () => {
        const postCheckAddressUpdate = useMutator<AddressChecked>();

        return useCallback((
    addressId: string,
    checkAddressUpdate: CheckAddressUpdate,
 signal?: AbortSignal
) => {
        return postCheckAddressUpdate(
          {url: `/intervention-preferences/${addressId}/address/check`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: checkAddressUpdate, signal
    },
          );
        }, [postCheckAddressUpdate])
      }
    


export const usePostCheckAddressUpdateMutationOptions = <TError = AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostCheckAddressUpdateHook>>>, TError,{addressId: string;data: CheckAddressUpdate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostCheckAddressUpdateHook>>>, TError,{addressId: string;data: CheckAddressUpdate}, TContext> => {

const mutationKey = ['postCheckAddressUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const postCheckAddressUpdate =  usePostCheckAddressUpdateHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostCheckAddressUpdateHook>>>, {addressId: string;data: CheckAddressUpdate}> = (props) => {
          const {addressId,data} = props ?? {};

          return  postCheckAddressUpdate(addressId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCheckAddressUpdateMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostCheckAddressUpdateHook>>>>
    export type PostCheckAddressUpdateMutationBody = CheckAddressUpdate
    export type PostCheckAddressUpdateMutationError = AppError | AppError | AppError

    export const usePostCheckAddressUpdate = <TError = AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostCheckAddressUpdateHook>>>, TError,{addressId: string;data: CheckAddressUpdate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostCheckAddressUpdateHook>>>,
        TError,
        {addressId: string;data: CheckAddressUpdate},
        TContext
      > => {

      const mutationOptions = usePostCheckAddressUpdateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useAcknowledgeWhatsNewFeatureHook = () => {
        const acknowledgeWhatsNewFeature = useMutator<null>();

        return useCallback((
    feature: 'agreed-place-picture',
 ) => {
        return acknowledgeWhatsNewFeature(
          {url: `/whats-new/${feature}`, method: 'DELETE'
    },
          );
        }, [acknowledgeWhatsNewFeature])
      }
    


export const useAcknowledgeWhatsNewFeatureMutationOptions = <TError = AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAcknowledgeWhatsNewFeatureHook>>>, TError,{feature: 'agreed-place-picture'}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAcknowledgeWhatsNewFeatureHook>>>, TError,{feature: 'agreed-place-picture'}, TContext> => {

const mutationKey = ['acknowledgeWhatsNewFeature'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const acknowledgeWhatsNewFeature =  useAcknowledgeWhatsNewFeatureHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useAcknowledgeWhatsNewFeatureHook>>>, {feature: 'agreed-place-picture'}> = (props) => {
          const {feature} = props ?? {};

          return  acknowledgeWhatsNewFeature(feature,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcknowledgeWhatsNewFeatureMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAcknowledgeWhatsNewFeatureHook>>>>
    
    export type AcknowledgeWhatsNewFeatureMutationError = AppError | AppError | AppError

    export const useAcknowledgeWhatsNewFeature = <TError = AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAcknowledgeWhatsNewFeatureHook>>>, TError,{feature: 'agreed-place-picture'}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useAcknowledgeWhatsNewFeatureHook>>>,
        TError,
        {feature: 'agreed-place-picture'},
        TContext
      > => {

      const mutationOptions = useAcknowledgeWhatsNewFeatureMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useGetPreferenceNotificationsHook = () => {
        const getPreferenceNotifications = useMutator<CombinedNotifications>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return getPreferenceNotifications(
          {url: `/intervention-preference-notifications`, method: 'GET', signal
    },
          );
        }, [getPreferenceNotifications])
      }
    

export const getGetPreferenceNotificationsQueryKey = () => {
    return [`/intervention-preference-notifications`] as const;
    }

    
export const useGetPreferenceNotificationsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetPreferenceNotificationsHook>>>, TError = AppError | AppError | AppError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPreferenceNotificationsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPreferenceNotificationsQueryKey();

  const getPreferenceNotifications =  useGetPreferenceNotificationsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetPreferenceNotificationsHook>>>> = ({ signal }) => getPreferenceNotifications(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPreferenceNotificationsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPreferenceNotificationsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetPreferenceNotificationsHook>>>>
export type GetPreferenceNotificationsQueryError = AppError | AppError | AppError


export function useGetPreferenceNotifications<TData = Awaited<ReturnType<ReturnType<typeof useGetPreferenceNotificationsHook>>>, TError = AppError | AppError | AppError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPreferenceNotificationsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetPreferenceNotificationsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetPreferenceNotificationsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPreferenceNotifications<TData = Awaited<ReturnType<ReturnType<typeof useGetPreferenceNotificationsHook>>>, TError = AppError | AppError | AppError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPreferenceNotificationsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetPreferenceNotificationsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetPreferenceNotificationsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPreferenceNotifications<TData = Awaited<ReturnType<ReturnType<typeof useGetPreferenceNotificationsHook>>>, TError = AppError | AppError | AppError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPreferenceNotificationsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPreferenceNotifications<TData = Awaited<ReturnType<ReturnType<typeof useGetPreferenceNotificationsHook>>>, TError = AppError | AppError | AppError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPreferenceNotificationsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetPreferenceNotificationsQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetDeliveryPreferenceHook = () => {
        const getDeliveryPreference = useMutator<DeliveryPreferenceResponse>();

        return useCallback((
    addressId: string,
 signal?: AbortSignal
) => {
        return getDeliveryPreference(
          {url: `/delivery-preferences/${addressId}`, method: 'GET', signal
    },
          );
        }, [getDeliveryPreference])
      }
    

export const getGetDeliveryPreferenceQueryKey = (addressId?: string,) => {
    return [`/delivery-preferences/${addressId}`] as const;
    }

    
export const useGetDeliveryPreferenceQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetDeliveryPreferenceHook>>>, TError = AppError | AppError | AppError>(addressId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDeliveryPreferenceHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDeliveryPreferenceQueryKey(addressId);

  const getDeliveryPreference =  useGetDeliveryPreferenceHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetDeliveryPreferenceHook>>>> = ({ signal }) => getDeliveryPreference(addressId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(addressId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDeliveryPreferenceHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDeliveryPreferenceQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetDeliveryPreferenceHook>>>>
export type GetDeliveryPreferenceQueryError = AppError | AppError | AppError


export function useGetDeliveryPreference<TData = Awaited<ReturnType<ReturnType<typeof useGetDeliveryPreferenceHook>>>, TError = AppError | AppError | AppError>(
 addressId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDeliveryPreferenceHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetDeliveryPreferenceHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetDeliveryPreferenceHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDeliveryPreference<TData = Awaited<ReturnType<ReturnType<typeof useGetDeliveryPreferenceHook>>>, TError = AppError | AppError | AppError>(
 addressId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDeliveryPreferenceHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetDeliveryPreferenceHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetDeliveryPreferenceHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDeliveryPreference<TData = Awaited<ReturnType<ReturnType<typeof useGetDeliveryPreferenceHook>>>, TError = AppError | AppError | AppError>(
 addressId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDeliveryPreferenceHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetDeliveryPreference<TData = Awaited<ReturnType<ReturnType<typeof useGetDeliveryPreferenceHook>>>, TError = AppError | AppError | AppError>(
 addressId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDeliveryPreferenceHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetDeliveryPreferenceQueryOptions(addressId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePutDeliveryPreferenceHook = () => {
        const putDeliveryPreference = useMutator<null>();

        return useCallback((
    addressId: string,
    updateDeliveryPreferenceRequest: UpdateDeliveryPreferenceRequest,
 ) => {
        return putDeliveryPreference(
          {url: `/delivery-preferences/${addressId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateDeliveryPreferenceRequest
    },
          );
        }, [putDeliveryPreference])
      }
    


export const usePutDeliveryPreferenceMutationOptions = <TError = AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutDeliveryPreferenceHook>>>, TError,{addressId: string;data: UpdateDeliveryPreferenceRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutDeliveryPreferenceHook>>>, TError,{addressId: string;data: UpdateDeliveryPreferenceRequest}, TContext> => {

const mutationKey = ['putDeliveryPreference'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const putDeliveryPreference =  usePutDeliveryPreferenceHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePutDeliveryPreferenceHook>>>, {addressId: string;data: UpdateDeliveryPreferenceRequest}> = (props) => {
          const {addressId,data} = props ?? {};

          return  putDeliveryPreference(addressId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutDeliveryPreferenceMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePutDeliveryPreferenceHook>>>>
    export type PutDeliveryPreferenceMutationBody = UpdateDeliveryPreferenceRequest
    export type PutDeliveryPreferenceMutationError = AppError | AppError | AppError

    export const usePutDeliveryPreference = <TError = AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutDeliveryPreferenceHook>>>, TError,{addressId: string;data: UpdateDeliveryPreferenceRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePutDeliveryPreferenceHook>>>,
        TError,
        {addressId: string;data: UpdateDeliveryPreferenceRequest},
        TContext
      > => {

      const mutationOptions = usePutDeliveryPreferenceMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useGetShouldSetupRingDoorbellHook = () => {
        const getShouldSetupRingDoorbell = useMutator<string[]>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return getShouldSetupRingDoorbell(
          {url: `/intervention-preferences/should-setup-ring-doorbell`, method: 'GET', signal
    },
          );
        }, [getShouldSetupRingDoorbell])
      }
    

export const getGetShouldSetupRingDoorbellQueryKey = () => {
    return [`/intervention-preferences/should-setup-ring-doorbell`] as const;
    }

    
export const useGetShouldSetupRingDoorbellQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetShouldSetupRingDoorbellHook>>>, TError = AppError | AppError | AppError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetShouldSetupRingDoorbellHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetShouldSetupRingDoorbellQueryKey();

  const getShouldSetupRingDoorbell =  useGetShouldSetupRingDoorbellHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetShouldSetupRingDoorbellHook>>>> = ({ signal }) => getShouldSetupRingDoorbell(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetShouldSetupRingDoorbellHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetShouldSetupRingDoorbellQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetShouldSetupRingDoorbellHook>>>>
export type GetShouldSetupRingDoorbellQueryError = AppError | AppError | AppError


export function useGetShouldSetupRingDoorbell<TData = Awaited<ReturnType<ReturnType<typeof useGetShouldSetupRingDoorbellHook>>>, TError = AppError | AppError | AppError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetShouldSetupRingDoorbellHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetShouldSetupRingDoorbellHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetShouldSetupRingDoorbellHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetShouldSetupRingDoorbell<TData = Awaited<ReturnType<ReturnType<typeof useGetShouldSetupRingDoorbellHook>>>, TError = AppError | AppError | AppError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetShouldSetupRingDoorbellHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetShouldSetupRingDoorbellHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetShouldSetupRingDoorbellHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetShouldSetupRingDoorbell<TData = Awaited<ReturnType<ReturnType<typeof useGetShouldSetupRingDoorbellHook>>>, TError = AppError | AppError | AppError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetShouldSetupRingDoorbellHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetShouldSetupRingDoorbell<TData = Awaited<ReturnType<ReturnType<typeof useGetShouldSetupRingDoorbellHook>>>, TError = AppError | AppError | AppError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetShouldSetupRingDoorbellHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetShouldSetupRingDoorbellQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetWhatsNewFeaturesHook = () => {
        const getWhatsNewFeatures = useMutator<WhatsNewFeatures>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return getWhatsNewFeatures(
          {url: `/whats-new`, method: 'GET', signal
    },
          );
        }, [getWhatsNewFeatures])
      }
    

export const getGetWhatsNewFeaturesQueryKey = () => {
    return [`/whats-new`] as const;
    }

    
export const useGetWhatsNewFeaturesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetWhatsNewFeaturesHook>>>, TError = AppError | AppError | AppError>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWhatsNewFeaturesHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWhatsNewFeaturesQueryKey();

  const getWhatsNewFeatures =  useGetWhatsNewFeaturesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetWhatsNewFeaturesHook>>>> = ({ signal }) => getWhatsNewFeatures(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWhatsNewFeaturesHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWhatsNewFeaturesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetWhatsNewFeaturesHook>>>>
export type GetWhatsNewFeaturesQueryError = AppError | AppError | AppError


export function useGetWhatsNewFeatures<TData = Awaited<ReturnType<ReturnType<typeof useGetWhatsNewFeaturesHook>>>, TError = AppError | AppError | AppError>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWhatsNewFeaturesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetWhatsNewFeaturesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetWhatsNewFeaturesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWhatsNewFeatures<TData = Awaited<ReturnType<ReturnType<typeof useGetWhatsNewFeaturesHook>>>, TError = AppError | AppError | AppError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWhatsNewFeaturesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetWhatsNewFeaturesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetWhatsNewFeaturesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWhatsNewFeatures<TData = Awaited<ReturnType<ReturnType<typeof useGetWhatsNewFeaturesHook>>>, TError = AppError | AppError | AppError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWhatsNewFeaturesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetWhatsNewFeatures<TData = Awaited<ReturnType<ReturnType<typeof useGetWhatsNewFeaturesHook>>>, TError = AppError | AppError | AppError>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetWhatsNewFeaturesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetWhatsNewFeaturesQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetAgreedPlacePictureHook = () => {
        const getAgreedPlacePicture = useMutator<Blob>();

        return useCallback((
    addressId: string,
 signal?: AbortSignal
) => {
        return getAgreedPlacePicture(
          {url: `/intervention-preferences/${addressId}/agreed-place-picture`, method: 'GET',
        responseType: 'blob', signal
    },
          );
        }, [getAgreedPlacePicture])
      }
    

export const getGetAgreedPlacePictureQueryKey = (addressId?: string,) => {
    return [`/intervention-preferences/${addressId}/agreed-place-picture`] as const;
    }

    
export const useGetAgreedPlacePictureQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetAgreedPlacePictureHook>>>, TError = AppError | AppError | AppError>(addressId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAgreedPlacePictureHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAgreedPlacePictureQueryKey(addressId);

  const getAgreedPlacePicture =  useGetAgreedPlacePictureHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetAgreedPlacePictureHook>>>> = ({ signal }) => getAgreedPlacePicture(addressId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(addressId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAgreedPlacePictureHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAgreedPlacePictureQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetAgreedPlacePictureHook>>>>
export type GetAgreedPlacePictureQueryError = AppError | AppError | AppError


export function useGetAgreedPlacePicture<TData = Awaited<ReturnType<ReturnType<typeof useGetAgreedPlacePictureHook>>>, TError = AppError | AppError | AppError>(
 addressId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAgreedPlacePictureHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAgreedPlacePictureHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetAgreedPlacePictureHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAgreedPlacePicture<TData = Awaited<ReturnType<ReturnType<typeof useGetAgreedPlacePictureHook>>>, TError = AppError | AppError | AppError>(
 addressId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAgreedPlacePictureHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAgreedPlacePictureHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetAgreedPlacePictureHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAgreedPlacePicture<TData = Awaited<ReturnType<ReturnType<typeof useGetAgreedPlacePictureHook>>>, TError = AppError | AppError | AppError>(
 addressId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAgreedPlacePictureHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAgreedPlacePicture<TData = Awaited<ReturnType<ReturnType<typeof useGetAgreedPlacePictureHook>>>, TError = AppError | AppError | AppError>(
 addressId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAgreedPlacePictureHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetAgreedPlacePictureQueryOptions(addressId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePutAgreedPlacePictureHook = () => {
        const putAgreedPlacePicture = useMutator<null>();

        return useCallback((
    addressId: string,
    putAgreedPlacePictureBody: Blob,
 ) => {
        return putAgreedPlacePicture(
          {url: `/intervention-preferences/${addressId}/agreed-place-picture`, method: 'PUT',
      headers: {'Content-Type': 'application/octet-stream', },
      data: putAgreedPlacePictureBody
    },
          );
        }, [putAgreedPlacePicture])
      }
    


export const usePutAgreedPlacePictureMutationOptions = <TError = AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutAgreedPlacePictureHook>>>, TError,{addressId: string;data: Blob}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutAgreedPlacePictureHook>>>, TError,{addressId: string;data: Blob}, TContext> => {

const mutationKey = ['putAgreedPlacePicture'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const putAgreedPlacePicture =  usePutAgreedPlacePictureHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePutAgreedPlacePictureHook>>>, {addressId: string;data: Blob}> = (props) => {
          const {addressId,data} = props ?? {};

          return  putAgreedPlacePicture(addressId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAgreedPlacePictureMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePutAgreedPlacePictureHook>>>>
    export type PutAgreedPlacePictureMutationBody = Blob
    export type PutAgreedPlacePictureMutationError = AppError | AppError | AppError

    export const usePutAgreedPlacePicture = <TError = AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutAgreedPlacePictureHook>>>, TError,{addressId: string;data: Blob}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePutAgreedPlacePictureHook>>>,
        TError,
        {addressId: string;data: Blob},
        TContext
      > => {

      const mutationOptions = usePutAgreedPlacePictureMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useDeleteAgreedPlacePictureHook = () => {
        const deleteAgreedPlacePicture = useMutator<null>();

        return useCallback((
    addressId: string,
 ) => {
        return deleteAgreedPlacePicture(
          {url: `/intervention-preferences/${addressId}/agreed-place-picture`, method: 'DELETE'
    },
          );
        }, [deleteAgreedPlacePicture])
      }
    


export const useDeleteAgreedPlacePictureMutationOptions = <TError = AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteAgreedPlacePictureHook>>>, TError,{addressId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteAgreedPlacePictureHook>>>, TError,{addressId: string}, TContext> => {

const mutationKey = ['deleteAgreedPlacePicture'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const deleteAgreedPlacePicture =  useDeleteAgreedPlacePictureHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteAgreedPlacePictureHook>>>, {addressId: string}> = (props) => {
          const {addressId} = props ?? {};

          return  deleteAgreedPlacePicture(addressId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAgreedPlacePictureMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteAgreedPlacePictureHook>>>>
    
    export type DeleteAgreedPlacePictureMutationError = AppError | AppError | AppError

    export const useDeleteAgreedPlacePicture = <TError = AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteAgreedPlacePictureHook>>>, TError,{addressId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteAgreedPlacePictureHook>>>,
        TError,
        {addressId: string},
        TContext
      > => {

      const mutationOptions = useDeleteAgreedPlacePictureMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deprecated. Use GET /delivery-preferences/:addressId
 * @deprecated
 */
export const useGetInterventionPreferenceHook = () => {
        const getInterventionPreference = useMutator<SinglePreference>();

        return useCallback((
    addressId: string,
 signal?: AbortSignal
) => {
        return getInterventionPreference(
          {url: `/intervention-preferences/${addressId}`, method: 'GET', signal
    },
          );
        }, [getInterventionPreference])
      }
    

export const getGetInterventionPreferenceQueryKey = (addressId?: string,) => {
    return [`/intervention-preferences/${addressId}`] as const;
    }

    
export const useGetInterventionPreferenceQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetInterventionPreferenceHook>>>, TError = AppError | AppError | AppError>(addressId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetInterventionPreferenceHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInterventionPreferenceQueryKey(addressId);

  const getInterventionPreference =  useGetInterventionPreferenceHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetInterventionPreferenceHook>>>> = ({ signal }) => getInterventionPreference(addressId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(addressId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetInterventionPreferenceHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInterventionPreferenceQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetInterventionPreferenceHook>>>>
export type GetInterventionPreferenceQueryError = AppError | AppError | AppError


export function useGetInterventionPreference<TData = Awaited<ReturnType<ReturnType<typeof useGetInterventionPreferenceHook>>>, TError = AppError | AppError | AppError>(
 addressId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetInterventionPreferenceHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetInterventionPreferenceHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetInterventionPreferenceHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInterventionPreference<TData = Awaited<ReturnType<ReturnType<typeof useGetInterventionPreferenceHook>>>, TError = AppError | AppError | AppError>(
 addressId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetInterventionPreferenceHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetInterventionPreferenceHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetInterventionPreferenceHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInterventionPreference<TData = Awaited<ReturnType<ReturnType<typeof useGetInterventionPreferenceHook>>>, TError = AppError | AppError | AppError>(
 addressId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetInterventionPreferenceHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useGetInterventionPreference<TData = Awaited<ReturnType<ReturnType<typeof useGetInterventionPreferenceHook>>>, TError = AppError | AppError | AppError>(
 addressId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetInterventionPreferenceHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetInterventionPreferenceQueryOptions(addressId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Deprecated. Use PUT /delivery-preferences/:addressId
 * @deprecated
 */
export const usePutInterventionPreferenceHook = () => {
        const putInterventionPreference = useMutator<CombinedPreferences>();

        return useCallback((
    addressId: string,
    updateInterventionPreference: UpdateInterventionPreference,
 ) => {
        return putInterventionPreference(
          {url: `/intervention-preferences/${addressId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateInterventionPreference
    },
          );
        }, [putInterventionPreference])
      }
    


export const usePutInterventionPreferenceMutationOptions = <TError = AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutInterventionPreferenceHook>>>, TError,{addressId: string;data: UpdateInterventionPreference}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutInterventionPreferenceHook>>>, TError,{addressId: string;data: UpdateInterventionPreference}, TContext> => {

const mutationKey = ['putInterventionPreference'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const putInterventionPreference =  usePutInterventionPreferenceHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePutInterventionPreferenceHook>>>, {addressId: string;data: UpdateInterventionPreference}> = (props) => {
          const {addressId,data} = props ?? {};

          return  putInterventionPreference(addressId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutInterventionPreferenceMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePutInterventionPreferenceHook>>>>
    export type PutInterventionPreferenceMutationBody = UpdateInterventionPreference
    export type PutInterventionPreferenceMutationError = AppError | AppError | AppError

    /**
 * @deprecated
 */
export const usePutInterventionPreference = <TError = AppError | AppError | AppError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutInterventionPreferenceHook>>>, TError,{addressId: string;data: UpdateInterventionPreference}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePutInterventionPreferenceHook>>>,
        TError,
        {addressId: string;data: UpdateInterventionPreference},
        TContext
      > => {

      const mutationOptions = usePutInterventionPreferenceMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
